import { useState } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton
} from '@mui/material'
import TextLabel from '../../../../../components/form/TextLabel/TextLabel'
import css from './DatosEmail.module.css'

const DatosEmail = ({ alumno, onEdit }) => {
  const [isExpanded, setExpanded] = useState(true)

  const handleChange = (_event, isExpanded) => {
    setExpanded(isExpanded)
  }

  const handleEdit = e => {
    e.stopPropagation()
    onEdit()
  }

  const emails = alumno.emails || []

  return (
    <Accordion expanded={isExpanded} onChange={handleChange}>
      <AccordionSummary
        expandIcon={<i className='material-icons'>expand_more</i>}
      >
        <div className={css.label}>
          <Typography className={css.title} variant='h2'>
            Datos de email
          </Typography>
          {isExpanded && (
            <IconButton
              className={css.button}
              size='small'
              color='secondary'
              onClick={handleEdit}
            >
              <i className='material-icons'>edit</i>
            </IconButton>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails className={css.details}>
        {emails.length === 0 ? (
          <div className={css.emptyState}>
            <Typography variant='body2' color='textSecondary'>
              No hay emails registrados
            </Typography>
          </div>
        ) : (
          <div className={css.emailsContainer}>
            {emails.map((email, index) => (
              <div key={index} className={css.emailRow}>
                <TextLabel
                  className={css.field}
                  name={`contacto-${index}`}
                  label='Contacto'
                  value={email.nombre || '-'}
                />
                <TextLabel
                  className={css.field}
                  name={`email-${index}`}
                  label='Email'
                  value={email.email}
                />
              </div>
            ))}
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  )
}

export default DatosEmail
